import PropTypes from "prop-types"

export const SEARCH_LIST_ELEM = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  subheader: PropTypes.string,
  allowDelete: PropTypes.bool,
})
